import store from '@/store';
import { uuid } from 'vue-uuid';

export default class BackgroundObject {
    // TODO:New Data
    data ={
      polygonWidth:            0,
      polygonHeight:           0,
      svgScaleX:               1,
      svgScaleY:               1,
      AllowMove:               'true',
      AllowResize:             'true',
      AllowRotate:             'true',
      Alpha:                   1,
      ColorSystem:             'CMYK',
      CurveCenterX:            undefined,
      CurveCenterY:            undefined,
      CurveEndAngle:           undefined,
      CurveHorizontalRadius:   undefined,
      CurveStartAngle:         undefined,
      CurveVerticalRadius:     undefined,
      DefaultColor:            undefined,
      StrokeColor:             undefined,
      StrokeWidth:             0,
      Height:                  undefined,
      Id:                      uuid.v1(),
      IsEditable:              'true',
      IsHFlipped:              false,
      IsVFlipped:              false,
      IsVisible:               true,
      LayerPanelValue:         false,
      Name:                    'Color 1',
      PageNo:                  0,
      PdfSortOrder:            '3',
      PolygonPoints:           undefined,
      RotateDegree:            0,
      RotateX:                 0,
      RotateY:                 0,
      SortOrder:               '1',
      UseRgb:                  false,
      Width:                   1304,
      X:                       211,
      Y:                       782,
      type:                    'shape',
      scaleX:                  1,
      scaleY:                  1,
      locked:                  false,
      isSelected:              false,
      initialX:                0,
      initialY:                0,
      shapeType:               'rectangle',
      isEditableForRightPanel: false,
      elementIndex:            -1,
      isNewObject:             false,
      svgContent:              '',
      animation:               {
        speed:     1,
        style:     '',
        startTime: 0.0,
        duration:  0.0,
        onEnter:   false,
        onExit:    false,
      },
      isAnimated: false,
      isGradient: false,
      gradient: {
        angle: 0,
        colors: [
          {
            id: '1',
            position: 0,
            color: 'red',
            isSelected: true,
            rgba: 'rgba(255,0,0,1)'
          },
          {
            id: '2',
            position: 94,
            color: 'yellow',
            isSelected: false,
            rgba: 'rgba(234,239,44,1)'
          },
        ]
      }
    }

    async initFromXML(xmlBackgroundObject) {
      for (const backgroundProperty of xmlBackgroundObject.children) {
        switch (backgroundProperty.tagName) {
          case 'Id':
            this.data.Id = backgroundProperty.innerHTML;
            break;
          case 'f':
            this.data.SelectedColorValueId = backgroundProperty.innerHTML;
            break;
          case 'Name':
            this.data.Name = backgroundProperty.innerHTML;
            break;
          case 'PageNo':
            this.data.PageNo = parseInt(backgroundProperty.innerHTML);
            break;
          case 'Width':
            this.data.Width = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'Height':
            this.data.Height = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'X':
            this.data.X = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'Y':
            this.data.Y = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'PdfSortOrder':
            this.data.PdfSortOrder = parseInt(backgroundProperty.innerHTML);
            break;
          case 'SortOrder':
            this.data.SortOrder = parseInt(backgroundProperty.innerHTML);
            break;
          case 'AllowMove':
            this.data.AllowMove = backgroundProperty.innerHTML;
            break;
          case 'AllowResize':
            this.data.AllowResize = backgroundProperty.innerHTML;
            break;
          case 'AllowRotate':
            this.data.AllowRotate = backgroundProperty.innerHTML;
            break;
          case 'PolygonPoints':
            this.data.PolygonPoints = backgroundProperty.innerHTML;
            break;
          case 'ColorType':
            this.data.ColorType = backgroundProperty.innerHTML;
            break;
          case 'ColorSystem':
            this.data.ColorSystem = backgroundProperty.innerHTML;
            break;
          case 'DefaultColor':
            this.data.DefaultColor = backgroundProperty.innerHTML;
            break;
          case 'IsEditable':
            this.data.IsEditable = (backgroundProperty.innerHTML && backgroundProperty.innerHTML.toLowerCase() == 'true');
            break;
          case 'IsVisible':
            this.data.IsVisible =  (backgroundProperty.innerHTML && backgroundProperty.innerHTML.toLowerCase() == 'true');
            break;
          case 'CurveCenterX':
            this.data.CurveCenterX = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'CurveCenterY':
            this.data.CurveCenterY = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'CurveStartAngle':
            this.data.CurveStartAngle = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'CurveEndAngle':
            this.data.CurveEndAngle = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'CurveHorizontalRadius':
            this.data.CurveHorizontalRadius = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'CurveVerticalRadius':
            this.data.CurveVerticalRadius = parseFloat(backgroundProperty.innerHTML);
            break;
          case 'Alpha':
            this.data.Alpha = backgroundProperty.innerHTML;
            break;
          case 'RotateDegree':
            this.data.RotateDegree = backgroundProperty.innerHTML;
            break;
        }
      }

      if (typeof this.data.CurveCenterX === 'number' && !this.data.PolygonPoints) {
        this.data.shapeType =  'ellipses';
        this.data.X         = this.data.CurveCenterX - this.data.CurveHorizontalRadius;
        this.data.Y         = this.data.CurveCenterY - this.data.CurveVerticalRadius;
      } else if (typeof this.data.CurveCenterX !== 'number' && this.data.PolygonPoints) {
        this.data.shapeType =  'polygon';
        try {
          const { Width, Height } = this.getWidthHeightFromPolygonPoint(this.data.PolygonPoints);
          this.data.Width         = Width;
          this.data.Height        = Height;
          this.data.polygonWidth  = Width;
          this.data.polygonHeight = Height;
        } catch (e) {

        }
      }

      if (this.data.ColorSystem == 'CMYK') {
        this.data.DefaultColor = store.getters.getRGBAllNewPmsColors(this.data.DefaultColor);
        this.data.DefaultColor = this.data.DefaultColor.startsWith('cmyk') ? store.getters.getRGBFromBankPMSColorListByCMYK(this.data.DefaultColor) : this.data.DefaultColor;
      }
      return this;
    }

    getWidthHeightFromPolygonPoint(polygonPoints) {
      const points  = polygonPoints.split(',');
      let minXPoint = 0,
        minYPoint = 0;
      let maxXPoint = minXPoint = parseFloat(points[0]);
      let maxYPoint = minYPoint = parseFloat(points[1]);
      for (let pointIndex = 0; pointIndex < points.length; pointIndex++) {
        const point = parseFloat(points[pointIndex]);

        if (pointIndex % 2 == 0) {
          if (maxXPoint < point) {
            maxXPoint = point;
          } else if (minXPoint > point) {
            minXPoint = point;
          }
        }

        if (pointIndex % 2 == 1) {
          if (maxYPoint < point) {
            maxYPoint = point;
          } else if (minYPoint > point) {
            minYPoint = point;
          }
        }
      }
      this.data.initialX = this.data.X =  this.data.X = minXPoint;
      this.data.initialY = this.data.Y =  this.data.Y = minYPoint;
      return { Width: maxXPoint - minXPoint, Height: maxYPoint - minYPoint };
    }
}
